module.exports = __webpack_public_path__ + "img/weixin.7bfc59ca.png";